module.exports = __webpack_public_path__ + "img/32_13.ccd2ba9e.png";